import { Navigate, useParams } from "react-router-dom";

const LegacySportingEventsRedirect = () => {
  const { brand, category } = useParams();

  if (!brand) return <Navigate replace to="/auth/login" />;

  const categoryPath = category ? `/${encodeURIComponent(category)}` : "";
  const path = `/auth/sporting-events/${encodeURIComponent(
    brand
  )}${categoryPath}`;

  return <Navigate replace to={path} />;
};

export default LegacySportingEventsRedirect;
